import { PinTypeWithNone } from '@/components/Map/Drawer/SearchDrawerWrapper/ResultsList/PinsList/PinsList.types';
import { PinType } from '@/types/pin';
import { Point } from '@/types/map';

const PIN_PATH2D =
  'M12.3077 0C6.25641 0 0 4.61538 0 12.3077C0 19.5897 11.0769 30.9744 11.5897 31.4872C11.7949 31.6923 12 31.7949 12.3077 31.7949C12.6154 31.7949 12.8205 31.6923 13.0256 31.4872C13.5385 30.9744 24.6154 19.6923 24.6154 12.3077C24.6154 4.61538 18.359 0 12.3077 0Z';

const PIN_SCALE: Point = {
  x: 1,
  y: 1,
};
const PIN_COVER_PATH2D =
  'M12.5 2C7.26267 2 2 5.93609 2 12.3871C2 13.7597 2.54385 15.5184 3.55264 17.5238C4.54347 19.4936 5.89191 21.5252 7.29136 23.3952C9.35206 26.1488 11.4511 28.4566 12.5022 29.569C13.5556 28.4621 15.6525 26.1723 17.7106 23.4313C19.1091 21.5689 20.4565 19.5418 21.4465 17.569C22.4535 15.5627 23 13.7891 23 12.3871C23 5.93609 17.7373 2 12.5 2ZM0 12.3871C0 4.64516 6.35417 0 12.5 0C18.6458 0 25 4.64516 25 12.3871C25 19.8194 13.75 31.1742 13.2292 31.6903C13.0208 31.8968 12.8125 32 12.5 32C12.1875 32 11.9792 31.8968 11.7708 31.6903C11.25 31.1742 0 19.7161 0 12.3871Z';

const COMMENT_PATH2D =
  'm 14.972,86.134 c -0.193,0 -0.388,-0.038 -0.574,-0.116 -0.551,-0.231 -0.909,-0.77 -0.909,-1.368 V 67.853 H 5.177 C 2.322,67.853 0,65.531 0,62.676 V 9.043 C 0,6.189 2.322,3.866 5.177,3.866 H 84.823 C 87.678,3.866 90,6.189 90,9.043 v 53.633 c 0,2.855 -2.322,5.177 -5.177,5.177 H 34.206 L 16.011,85.709 c -0.283,0.278 -0.658,0.425 -1.039,0.425 z';

const COMMENT_SCALE: Point = {
  x: 0.38,
  y: 0.38,
};

export type PinIcon = 'pin' | 'pin-cover' | 'comment';

export interface PinSize {
  width: number;
  height: number;
}

const PIN_SIZE: PinSize = {
  width: 25,
  height: 32,
};
const COMMENT_SIZE: PinSize = {
  width: 32,
  height: 32,
};

export const PINS_COLORS: Record<PinType, string> = {
  drugs: '#F48C41',
  chemicals: '#008325',
  modelElement: '#106AD7',
  comment: '#106AD7',
};

export const PINS_COLOR_WITH_NONE: Record<PinTypeWithNone, string> = {
  ...PINS_COLORS,
  none: '#000000',
};

export const LINE_COLOR = '#00AAFF';

export const TEXT_COLOR = '#FFFFFF';

export const LINE_WIDTH = 6;

export const MULTIICON_RATIO = 0.2;

export const getPinPath = (type: PinIcon): string => {
  switch (type) {
    case 'pin':
      return PIN_PATH2D;
    case 'pin-cover':
      return PIN_COVER_PATH2D;
    case 'comment':
      return COMMENT_PATH2D;
    default:
      throw new Error(`Unknown pin type: ${type}`);
  }
};

export const getPinScale = (type: PinIcon): Point => {
  switch (type) {
    case 'pin':
      return PIN_SCALE;
    case 'pin-cover':
      return PIN_SCALE;
    case 'comment':
      return COMMENT_SCALE;
    default:
      throw new Error(`Unknown pin type: ${type}`);
  }
};
export const getPinSize = (type: PinIcon): PinSize => {
  switch (type) {
    case 'pin':
      return PIN_SIZE;
    case 'pin-cover':
      return PIN_SIZE;
    case 'comment':
      return COMMENT_SIZE;
    default:
      throw new Error(`Unknown pin type: ${type}`);
  }
};
